<template>
  <div class="ScheduleTable">
    <div class="head-wrap">
      <div>
        <slot name="head-left"></slot>
      </div>
      <div class="button-wrap">
        <el-button size="medium" @click="onChangeWeek('pre')">上周</el-button>
        <el-button size="medium" @click="onChangeWeek('next')">下周</el-button>
        <el-button size="medium" @click="onChangeWeek('cur')">
          返回今天
        </el-button>
      </div>
    </div>
    <table class="table" v-if="table.date.length">
      <thead>
        <tr>
          <th></th>
          <th v-for="(date, index) in table.date" :key="index">
            <p class="week">
              星期{{ index == 6 ? "日" : $pub.toChinesNum(index + 1) }}
            </p>
            <p
              class="date today"
              v-if="nowDate.format('yyyy-MM-dd') == date.date"
            >
              {{ date.str }} 今天
            </p>
            <p class="date" v-else>{{ date.str }}</p>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(time, courseTimeIndex) in table.course_time"
          :key="courseTimeIndex"
        >
          <td class="time">{{ time.time_name }}</td>
          <td
            v-for="(date, weekIndex) in table.date"
            :key="weekIndex"
            class="course-time"
            @click="onClickCourseTime(weekIndex, time)"
          >
            <slot name="course-time" :weekIndex="weekIndex" :time="time"></slot>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "ScheduleTable",
  props: {
    // 请求url
    url: {
      required: true,
      type: String,
    },
    // 讲师id
    teacherId: {
      required: true,
    },
  },
  data() {
    return {
      event: {
        clickCourseTime: "click-course-time", // 点击课次
        getTableData: "get-table-data", // 获取排期表数据
      },
      nowDate: new Date(),
      curWeek: 0, // 0-本周  小于0-上周  大于0-下周
      table: {
        date: [],
        course_time: [],
        invite_course: [],
        course_arrange: [],
      },
    };
  },
  created() {
    this.requestTable();
  },
  methods: {
    // on event
    // 切换周 action: cur-本周 pre-上周 next-下周
    onChangeWeek(action = "cur") {
      if (action == "cur") {
        this.curWeek = 0;
      } else if (action == "pre") {
        this.curWeek--;
      } else {
        this.curWeek++;
      }
      this.requestTable();
    },
    onClickCourseTime(weekIndex, time) {
      this.$emit(this.event.clickCourseTime, {
        weekIndex,
        time,
      });
    },
    // request
    /**
     * 获取排期表
     * week 小于0:上周   等于0:本周  大于0:下周； 不传用当前周
     */
    async requestTable(week) {
      if (week === undefined) {
        week = this.curWeek;
      }
      // console.log(this.url, this.teacherId);
      if (!this.url || !this.teacherId) return;
      this.table = await this.$http.get(this.url, {
        week,
        teacher_id: this.teacherId,
      });
      this.table.date = this.table.date.map(i => {
        const dateAry = i.split("-");
        return {
          date: i,
          str: `${dateAry[1]}-${dateAry[2]}`,
        };
      });
      // get data
      this.$emit(this.event.getTableData, this.table);
    },
  },
};
</script>

<style lang="scss" scoped>
.head-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.table {
  width: 100%;
  border: 1px solid #ebebeb;
  border-collapse: collapse;
  table-layout: fixed;
  thead {
    background-color: #f2f2f2;
  }
  tbody tr:nth-of-type(2n) {
    background-color: #fbfbfb;
  }
  th,
  td {
    border: 1px solid #ebebeb;
    text-align: center;
    font-size: 14px;
  }
  th {
    padding: 13px 10px;
    width: 12.5%;
    .week {
      color: #333;
      font-weight: bold;
    }
    .date {
      color: #999;
      font-weight: 400;
      &.today {
        color: #333;
      }
    }
  }
  td {
    text-align: left;
    height: 54px;
    &.time {
      color: #333;
      font-weight: bold;
      text-align: center;
    }
    &.course-time {
      cursor: pointer;
      padding: 0;
    }
  }
}
.button-wrap {
  /deep/ .el-button {
    span {
      color: #333;
    }
  }
}
</style>
